// export const baseURL = "http://localhost:4545/"

export const baseURL = "https://api.mobipoll.co.ke/api/v1/";

// Warning std versions prefixed with 'v' will be deprecated on October 1st 2020. Please change your import to  (at https://deno.land/std@v0.63.0/fmt/colors.ts)
// http://localhost:8090